export default {
  getList: (data: any) => data?.list || [],
}
